import React, { Component } from "react";

class ValidationTextArea extends Component {
  state = {
    hasError: false
  };
  constructor(props) {
    super(props);
    props.onBlur({ name: props.name, hasError: true });
  }
  componentDidMount() {
    if (this.props.defaultValue) {
      this.props.onBlur({ name: this.props.name, hasError: !this.validate(this.props.defaultValue) });
    }
  }
  validate = value => {
    return value !== "";
  };
  handleOnEvent = (event, onEvent) => {
    const value = event.target.value;
    this.setState({ hasError: !this.validate(value) });
    onEvent({ name: this.props.name, hasError: !this.validate(value) }, event);
  };
  render() {
    const {
      defaultValue,
      onChange,
      name,
      onBlur,
      placeholder,
      type,
      rows
    } = this.props;
    const errorClass = "aps-section-register-fields-required";
    return (
      <textarea
        className={`uk-textarea aps-section-register-fields ${
          this.state.hasError ? errorClass : ""
        }`}
        type={type}
        placeholder={placeholder}
        name={name}
        rows={rows}
        defaultValue={defaultValue}
        onBlur={event => this.handleOnEvent(event, onBlur)}
        onChange={event => this.handleOnEvent(event, onChange)}
      />
    );
  }
}
export default ValidationTextArea;



// WEBPACK FOOTER //
// ./src/components/ValidationTextarea/index.js